export const getParams = () => {
  // 抓取當前 url
  const curUrl = typeof window !== "undefined" ? window.location.search : null
  // 建立物件，才不會遇到抓取第一個參數失敗的問題

  const searchParams = new URLSearchParams(curUrl)

  const tag = searchParams.get("tag")
  const type = searchParams.get("type")

  return [tag, type]
}
